/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Members_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Members are the individual people in your organization. Teams are groups you build from those members to grant access to projects, spaces, and models together." |
*
* @param {Uno_Edu_Intro_Members_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_members_chip2_answer = /** @type {((inputs?: Uno_Edu_Intro_Members_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Members_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglieder sind die einzelnen Personen in Ihrer Organisation. Teams sind Gruppen, die Sie aus diesen Mitgliedern bilden, um gemeinsam Zugriff auf Projekte, Spaces und Modelle zu gewähren.")
	return /** @type {LocalizedString} */ ("Members are the individual people in your organization. Teams are groups you build from those members to grant access to projects, spaces, and models together.")
});